import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll<HTMLElement>("[data-gsap]").forEach(el => {
    const animationType = el.dataset.gsap;
    const start = el.dataset.gsapStart || "top bottom";
    const end = el.dataset.gsapEnd || "top top";
    const trigger = el.dataset.gsapTrigger || el;
    const duration = el.dataset.gsapDuration || 0.5;
    const scrub = el.dataset.gsapScrub != null;
    const offsetYTo = el.dataset.gsapOffsetYTo || 0;

    if (animationType === "fade-in") {
        const fromProperties: Record<string, any> = {
            opacity: 0
        };
        const toProperties = {
            opacity: 1
        };

        if (offsetYTo) {
            fromProperties['y'] = 0;
            toProperties['y'] = offsetYTo;
        }

        gsap.fromTo(el, 
            {
                ...fromProperties
            },
            {
                ...toProperties,
                scrollTrigger: {
                    trigger: trigger,
                    start: start,
                    end: end,
                    scrub: scrub,
                    toggleActions: "play none none reverse", // play when enters, reverse when leaves
                },
                duration: duration, // Optional: Add a duration for the animation
                immediateRender: false // important!
        });
    }

    if (animationType === "fade-out") {
        const fromProperties: Record<string, any> = {
            opacity: 1
        };
        const toProperties = {
            opacity: 0
        };

        if (offsetYTo) {
            fromProperties['y'] = 0;
            toProperties['y'] = offsetYTo;
        }

        gsap.fromTo(el, 
            {
                ...fromProperties
            },
            {
                ...toProperties,
                scrollTrigger: {
                    trigger: trigger,
                    start: start,
                    end: end,
                    scrub: scrub,
                    toggleActions: "play none none reverse", // play when enters, reverse when leaves
                },
                duration: duration, // Optional: Add a duration for the animation
                immediateRender: false // important!
        });
    }
  
    // You can extend this to support more animation types
});

window.addEventListener('load', () => {
ScrollTrigger.refresh(); // recalculate trigger positions after everything is loaded
});